export const HEADER_PANIER = {
  mySelection: 'Votre Sélection',
  continueSelection: 'Continuer la sélection',
  buttonCreate: 'Créer ma recommandation',
  buttonModif: 'Modifier ma recommandation',
  resetPanier: 'Vider le panier',
  modalConfimationMessage: 'Etes-vous sûr de vouloir vider votre panier ?',
  modalConfirmationInfo: 'La suppression du panier est irréversible',
  libelleBtnValide: 'Vider le panier',
  labelThemeCampagne: 'Thème de campagne',
  assistant: 'Chargé de budget',
  afficherPanneauxSousContrat: 'Afficher les panneaux sous contrat',
};
export const PRODUITS_PANIER = {
  labelPrixBrut: 'Brut',
  labelPrixBrutNegocie: 'Brut Négocié',
  labelPrixNetAnnuel: 'Net période',
  labelPrixNetBudgetaire: 'Net facturé',
  labelTLPE: 'TLPE',
  labelFraisTechnique: 'Frais technique',
  labelHonoraires: 'Honoraires',
  labelTotalHonoraires: 'Total honoraires',
  labelCommentaire: 'Commentaire',
  buttonDelete: 'Supprimer',
  messagePanneauVide: 'Votre panier est vide',
  tabBudget: {
    index: 'N°',
    ancienPanneau: 'Sous contrat',
    referencePanneau: 'Référence',
    regie: 'Régie',
    format: 'Format',
    materiel: 'Type',
    categorie: 'Catégorie',
    date: 'Date',
    adresse: 'Adresse',
    prixBrutNegocie: 'Budget Brut HT',
    prixNet: 'Budget Net HT',
    tlpe: 'TLPE',
    honoraires: 'Honoraires HT',
    honoraireFraisTraitement: 'Frais de traitement HT',
    fraisTechnique: 'Frais tech. HT',
    prixTotal: 'TOTAL',
  },
  libelleTabBudgetAnnuel: 'Tableau budget',
  libelleTabBudgetProrata: 'Tableau budget proratisé',
  libelleCommentaire: 'Préconisation {societe}'
};
